import { APIProvider } from '@vis.gl/react-google-maps'
import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import {
    ACTION_CONTAINER,
    AURRETIK_CONTAINER,
    CATEGORIES_CONTAINER,
    FINDER_CONTAINER,
    HARTU_BOOKING_CONTAINER,
    HARTU_CANCELATION_CONTAINER,
    HARTU_CONTAINER,
    HARTU_LOGIN_CHECK_CONTAINER,
    HARTU_THANKYOUPAGE_CONTAINER,
    HARTU_FAILPAGE_CONTAINER,
    INCIDENCE_CONTAINER,
    INDICATORS_CONTAINER,
    IRUDIZ_CONTAINER,
    MAPS_CONTAINER,
    NEWS_CONTAINER,
    NEW_INCIDENCE_CONTAINER,
    PAGE_CONTAINER,
    PLAN_CONTAINER,
    PLAN_PROGRESS_CONTAINER,
    PLAN_SUMMARY_CONTAINER,
    USER_BOOKINGS_CONTAINER,
    USER_DATA_CONTAINER,
} from './constants/containersId'
import BaseContainer from './containers/BaseContainer/BaseContainer'
import ErrorBoundary from './helpers/ErrorBoundary'
import ScrollToTop from './helpers/ScrollToTop'
import {
    ACTIONS_BY_SLUG,
    AURRETIK,
    AURRETIK_FACILITY,
    HARTU,
    HARTU_BOOKING,
    HARTU_CANCELATION,
    HARTU_LOGIN_CHECK,
    HARTU_THANK_YOU,
    HARTU_FAIL,
    INCIDENCES_BY_ID,
    INCIDENCES_NEW,
    IRUDIZ_POSTALS,
    LOGIN,
    MAPS,
    PAGE,
    PAGES_BY_SLUG,
    PAGE_CATEGORIES,
    PAGE_INDICATORS,
    PLANS_BY_SLUG,
    PLANS_BY_SLUG_PROGRESS,
    PLANS_BY_SLUG_SUMMARY,
    PLANS_SEARCH,
    USER_BOOKINGS,
    USER_DATA,
    MI_PAGO_FORM
} from './routing/routes'
import {
    getKeyForApi,
    getToken,
} from './store/actions'
import { setSelectedUA } from './store/actions'
import getLangByLocation from './utils/getLangByLocation'
import getLocaleByLocation from './utils/getLocaleByLocation'
import MiPagoRedirectContainer from './containers/MiPagoRedirectContainer/MiPagoRedirectContainer'

function App({ setSelectedUAStore, data }) {
    const [analyticsInitialized, setAnalyticsInitialized] = useState(false)
    const location = useLocation()
    const lang = location && getLangByLocation(location)
    const locale = getLocaleByLocation(location)

    const clearCookies = () => {
        const cookies = document.cookie.split(";");
        cookies.forEach(cookie => {
           
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (!name.includes('SID')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        });
      };

    useEffect(() => {
        document.documentElement.lang = lang
        clearCookies();
    }, [lang])

    useEffect(() => {
        const page = {
            domain: encodeURIComponent(
                window.location.href.replace(location.pathname, '')
            ),
        }
       // setSelectedUAStore(page)

        if (data && !analyticsInitialized) {
            ReactGA.initialize(data.analitycs)
            setAnalyticsInitialized(true)
        }
    }, [analyticsInitialized])

    return (
        <ErrorBoundary>
            <ScrollToTop>
                <APIProvider
                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
                    language={lang} 
                >
                    <div>
                        <Routes>
                            <Route
                                path="/"
                                element={<Navigate to={locale} />}
                            />
                            <Route
                                path={MAPS[lang]}
                                element={
                                    <BaseContainer
                                        containerId={MAPS_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path="/:lang"
                                element={
                                    <BaseContainer
                                        containerId={PAGE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={IRUDIZ_POSTALS[lang]}
                                element={
                                    <BaseContainer
                                        containerId={IRUDIZ_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={HARTU[lang]}
                                element={
                                    <BaseContainer
                                        containerId={HARTU_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={HARTU_CANCELATION[lang]}
                                element={
                                    <BaseContainer
                                        containerId={
                                            HARTU_CANCELATION_CONTAINER
                                        }
                                    />
                                }
                            />
                            <Route
                                path={HARTU_LOGIN_CHECK[lang]}
                                element={
                                    <BaseContainer
                                        containerId={
                                            HARTU_LOGIN_CHECK_CONTAINER
                                        }
                                    />
                                }
                            />
                            <Route
                                path={HARTU_BOOKING[lang]}
                                element={
                                    <BaseContainer
                                        containerId={HARTU_BOOKING_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PAGE}
                                element={
                                    <BaseContainer
                                        containerId={PAGE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={AURRETIK}
                                element={
                                    <BaseContainer
                                        containerId={AURRETIK_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={AURRETIK_FACILITY}
                                element={
                                    <BaseContainer
                                        containerId={AURRETIK_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={INCIDENCES_BY_ID}
                                element={
                                    <BaseContainer
                                        containerId={INCIDENCE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={INCIDENCES_NEW[lang]}
                                element={
                                    <BaseContainer
                                        containerId={NEW_INCIDENCE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PLANS_SEARCH[lang]}
                                element={
                                    <BaseContainer
                                        containerId={FINDER_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PLANS_BY_SLUG_PROGRESS[lang]}
                                element={
                                    <BaseContainer
                                        containerId={PLAN_PROGRESS_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PLANS_BY_SLUG_SUMMARY}
                                element={
                                    <BaseContainer
                                        containerId={PLAN_SUMMARY_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PLANS_BY_SLUG[lang]}
                                element={
                                    <BaseContainer
                                        containerId={PLAN_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={ACTIONS_BY_SLUG[lang]}
                                element={
                                    <BaseContainer
                                        containerId={ACTION_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PAGES_BY_SLUG}
                                element={
                                    <BaseContainer
                                        containerId={NEWS_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PAGE_INDICATORS[lang]}
                                element={
                                    <BaseContainer
                                        containerId={INDICATORS_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={PAGE_CATEGORIES[lang]}
                                element={
                                    <BaseContainer
                                        containerId={CATEGORIES_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={USER_BOOKINGS[lang]}
                                element={
                                    <BaseContainer
                                        containerId={USER_BOOKINGS_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={LOGIN[lang]}
                                element={
                                    <BaseContainer
                                        containerId={PAGE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={USER_DATA[lang]}
                                element={
                                    <BaseContainer
                                        containerId={USER_DATA_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={HARTU_THANK_YOU[lang]}
                                element={
                                    <BaseContainer
                                        containerId={HARTU_THANKYOUPAGE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={HARTU_FAIL[lang]}
                                element={
                                    <BaseContainer
                                        containerId={HARTU_FAILPAGE_CONTAINER}
                                    />
                                }
                            />
                            <Route
                                path={MI_PAGO_FORM[lang]}
                                element={<MiPagoRedirectContainer />}
                            />
                        </Routes>
                    </div>
                </APIProvider>
            </ScrollToTop>
        </ErrorBoundary>
    )
}

const mapStateToProps = ({ analyticsUA, analyticsUAs }) => ({
    analyticsUA,
    data: analyticsUAs[analyticsUA.domain],
})

const mapDispatchToProps = (dispatch) => ({
  //  setSelectedUAStore: (payload) => dispatch(setSelectedUA(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
